export default __webpack_public_path__ + "static/cabin-deluxe-2-to-4-1-c57d51a7abf55029595ed1a6e7b97011.jpg";